import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { useTimingTransition } from 'react-native-redash';
import Animated, {
  cond,
  eq,
  sub,
  interpolate,
  Extrapolate,
  add,
} from 'react-native-reanimated';

export const OverlayInput = memo(
  ({ renderButton, children, isVisible = false, containerLayout }) => {
    const { styles } = useStyle();

    const progress = useTimingTransition(isVisible);
    const opacity = interpolate(progress, {
      inputRange: [0, 0.3, 1],
      outputRange: [0, 0.1, 1],
      extrapolate: Extrapolate.CLAMP,
    });
    const pointerEvents = cond(eq(progress, 1), 'auto', 'none');
    const top = sub(containerLayout.offsetY, 20, 0);
    const height = add(containerLayout.height, 0);

    return (
      <>
        <View style={styles.mainContainer}>{renderButton?.()}</View>
        <Animated.View
          pointerEvents={pointerEvents}
          style={{
            zIndex: 10,
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            top,
            height,
            opacity,
          }}
        >
          {children}
        </Animated.View>
      </>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  mainContainer: {
    backgroundColor: colors.white,
  },
  headerContainer: {
    alignItems: 'flex-end',
  },
}));
